import store from '@/store'
export default [
  {
    path: '/term-semesters',
    name: 'term-semester',
    meta: { requiresAuth: true },
    component: () => import('@/pages/term-semester/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('termSemester/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/term-semesters/create',
    name: 'term-semester-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/term-semester/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('termSemester/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/term-semesters/:id',
    name: 'term-semester-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/term-semester/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('termSemester/find', to.params.id)
      next()
    }
  }
]
